import RecentlySearched from './RecentlySearched';

export default RecentlySearched;
